const jobsPage = {
  label: 'CAREERS',
  title: 'Current Openings',
  description:
    'Explore current opportunities at FactorStreet. More roles will be added as our projects grow.',
};

const applyPage = {
  label: 'CAREERS',
  title: 'Apply Now',
  description:
    'Share your profile for future opportunities across technology, education, operations, and marketing.',
};

export const careerPages = {
  jobs: jobsPage,
  apply: applyPage,
  'current-opening': jobsPage,
  'apply-now': applyPage,
};
